// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile-detail-block[data-v-6eecc5b6] {
  display: flex;
  align-items: center;
  padding: 15px;
}
.profile-detail-block .profile-img-block[data-v-6eecc5b6] {
  position: relative;
  margin: 0 10px 0 0;
}
.profile-detail-block h4[data-v-6eecc5b6] {
  font-size: 16px;
  line-height: 20px;
}
.profile-detail-block h5[data-v-6eecc5b6] {
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 0;
}
.profile-right[data-v-6eecc5b6] {
  text-align: left;
}
.profile-right a[data-v-6eecc5b6] {
  display: inline-block;
  color: #607d8b;
  font-size: 12px;
  line-height: 16px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
